/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NetworkStatusTimespan } from './networkStatusTimespan';
import { Comment } from './comment';
import { DataPlanTimespan } from './dataPlanTimespan';
import { Build } from './build';
import { StringTimespan } from './stringTimespan';
import { LongTimespan } from './longTimespan';
import { ParameterData } from './parameterData';
import { ComProviderTimespan } from './comProviderTimespan';


export interface TrapDto { 
    _class: string;
    airtimeNetworkStatusChangeRequested?: TrapDto.AirtimeNetworkStatusChangeRequestedEnum;
    batteryTimeline?: Array<StringTimespan>;
    bootloaderVersionId?: string;
    buildInProduction?: Build;
    comId?: string;
    comIdTimeline?: Array<StringTimespan>;
    comProviderTimeline?: Array<ComProviderTimespan>;
    comType?: TrapDto.ComTypeEnum;
    comments?: Array<Comment>;
    currentBuild?: Build;
    dataPlanTimeline?: Array<DataPlanTimespan>;
    deviceTypeId?: string;
    firmwareVersionId?: string;
    gpsPlusDevice?: boolean;
    id?: number;
    idDevice?: number;
    insertTs?: string;
    knownToSendBrokenMessages?: boolean;
    networkStatusTimeline?: Array<NetworkStatusTimespan>;
    nfcTagUid?: string;
    parameterDataList?: Array<ParameterData>;
    paymentAccountTimeline?: Array<LongTimespan>;
    pcbTypeId?: string;
    previousBuilds?: Array<Build>;
    replacedById?: number;
    testDevice?: boolean;
    updateTs?: string;
    userSubsystemVisibility?: Array<boolean>;
    warranty?: string;
}
export namespace TrapDto {
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
}


